export default __webpack_public_path__ + "static/media/lds-logo_zh-hans.4100ce6887a9b664.svg";